import type { ExpertPlan } from "@shopexperts/legacy-api";

export interface DeletePlanCopy {
  title: string;
  text: string;
  primaryActionLabel: string;
  secondaryActionLabel: string;
  isRisky: boolean;
}

/**
 * Builds the dialog copy used when an admin asks to delete a plan. When a
 * plan still has linked subscriptions we surface a stronger warning and
 * recommend deactivating instead — the API allows the delete, but it can
 * break historical billing records, so the admin should confirm intent.
 */
export function buildDeletePlanCopy(plan: Pick<ExpertPlan, "name" | "subscriptions_count"> | null | undefined): DeletePlanCopy {
  const name = plan?.name?.trim() || "this plan";
  const count = plan?.subscriptions_count ?? 0;

  if (count > 0) {
    const noun = count === 1 ? "expert subscription" : "expert subscriptions";
    return {
      title: `Delete "${name}"?`,
      text: `${count} ${noun} ${count === 1 ? "is" : "are"} linked to "${name}". Deleting it may break historical billing data — we recommend deactivating the plan instead. Continue anyway?`,
      primaryActionLabel: "Delete Plan",
      secondaryActionLabel: "Cancel",
      isRisky: true,
    };
  }

  return {
    title: `Delete "${name}"?`,
    text: `Are you sure you want to delete "${name}"? This action cannot be undone.`,
    primaryActionLabel: "Delete Plan",
    secondaryActionLabel: "Cancel",
    isRisky: false,
  };
}
